import axios from "axios";

export default class WechatSdk{

    constructor() {
        wx.error(function(res){
            console.log('wechat sdk error', res);
        });
    }

    config(apis, url) {
        axios.post("wechat/config", {apis:apis, url:window.location.origin + url})
            .then(({data}) => {
                wx.config(data);
            })
    }

    static updateAppMessageShareData(shareData) {
        wx.ready(function () {
            wx.updateAppMessageShareData({
                success: function () {
                    // 设置成功
                },
                ...shareData
            });
        });
    }
    static updateTimelineShareData(shareData) {
        wx.ready(function () {
            wx.updateTimelineShareData({
                success: function () {
                    // 设置成功
                },
                ...shareData
            });
        });
    }
}